import React from "react";
import styles from "./InfoSection.module.css";
import dayjs from "dayjs";
import CustomiseCta from "../CustomiseCta/CustomiseCta";

const InfoSection = ({ data }: any) => {
  const { data_time, title_description, cta } = data;

  const formattedDate = data_time ? dayjs(data_time).format("D MMM YYYY") : "";
  const formattedTime = data_time ? dayjs(data_time).format("h:mm A") : "";

  const updatedDescription = title_description?.description
    .replace("[Insert Date]", formattedDate)
    .replace("[Insert Time]", formattedTime);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.textContainer}>
          <h3 className={styles.header}>{title_description?.title}</h3>
          <p className={styles.subHeader}>{updatedDescription}</p>
        </div>
        {cta && (
          <div className={styles.buttonContainer}>
            <CustomiseCta ctaData={cta} />
          </div>
        )}
      </div>
    </>
  );
};

export default InfoSection;
